export default __webpack_public_path__ + "9b88f1b9af6f5cc56e58e4edccb48361.svg";